export default {
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    loading: '読み込み中...',
    success: '操作成功',
    error: '操作失敗',
    networkError: 'ネットワークエラー'
  },
  nav: {
    home: 'ホーム',
    card: '名刺',
    contacts: '連絡先',
    chat: 'チャット',
    profile: 'プロフィール'
  },
  profile: {
    title: 'プロフィール',
    personalInfo: '個人情報',
    editProfile: 'プロフィール編集',
    myCards: 'マイ名刺',
    myContacts: 'マイ連絡先',
    settings: '設定',
    logout: 'ログアウト',
    totalVisitors: '総訪問者数',
    friendCount: '友達数',
    todayVisitors: '今日の訪問者',
    todayIncrement: '今日の増加'
  },
  settings: {
    accountSecurity: 'アカウントセキュリティ',
    notificationSettings: '通知設定',
    languageSettings: '言語設定',
    logout: 'ログアウト',
    accountSecurityDesc: 'パスワードの変更、携帯電話のバインドなど',
    notificationSettingsDesc: 'メッセージ通知の設定を管理する',
    languageSettingsDesc: 'アプリの言語を選択する',
    logoutDesc: '現在のアカウントから安全にログアウトする'
  },
  language: {
    title: '言語設定',
    selectLanguage: '言語を選択',
    zhCN: '中国語（簡体字）',
    enUS: '英語',
    jaJP: '日本語',
    koKR: '韓国語',
    ruRU: 'ロシア語'
  },
  contact: {
    sameLevel: '同じレベルの連絡先',
    higherLevel: '上位レベルの連絡先',
    goldMember: 'ゴールド会員',
    platinumMember: 'プラチナ会員',
    diamondMember: 'ダイヤモンド会員',
    unlock: 'ロック解除',
    contact: '連絡',
    unlockContact: '連絡先のロックを解除',
    upgradeForContacts: 'より多くの連絡先を解除するには会員をアップグレード'
  },
  storage: {
    basicPlan: 'ベーシックプラン',
    professionalPlan: 'プロフェッショナルプラン',
    enterprisePlan: 'エンタープライズプラン',
    month: '月',
    features: {
      basic: ['50GBストレージ', '基本セキュリティ', 'ファイル共有'],
      professional: ['200GBストレージ', '高度なセキュリティ暗号化', 'チームコラボレーション', '優先カスタマーサービス'],
      enterprise: ['1TBストレージ', 'エンタープライズレベルのセキュリティ', '無制限のコラボレーション', '専用カスタマーサービス']
    },
    buyStorage: 'ストレージを購入',
    buyPlan: 'プランを購入',
    uploadFile: 'ファイルをアップロード',
    viewFiles: 'ファイルを表示',
    downloadAll: '一括ダウンロード',
    documents: '文書',
    images: '画像',
    videos: '動画',
    others: 'その他'
  },
  menu: {
    myCards: 'マイ名刺',
    myCardsDesc: 'デジタル名刺を管理',
    memberCenter: 'メンバーセンター',
    memberCenterDesc: '会員をアップグレードしてより多くの特典を',
    myFavorites: 'マイお気に入り',
    myFavoritesDesc: '保存したコンテンツを表示',
    myRelations: 'マイ関係',
    myRelationsDesc: 'ソーシャル関係を管理',
    chat: 'チャット＆社交',
    chatDesc: '友達とチャットして交流',
    contacts: '連絡先',
    contactsDesc: '連絡先を管理',
    privacy: 'プライバシー設定',
    privacyDesc: 'プライバシー権限を管理'
  }
}
